export const FORM_UPDATE_VALUE = 'FORM_UPDATE_VALUE';



// WEBPACK FOOTER //
// ./src/redux/actions/actionTypes.js